// @ts-nocheck
import { Slash } from "@insite/mobius/Breadcrumbs";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        typographyProps: {
            color: "primary",
            size: "inherit",
        },
        css: css`
            padding: ${pxToRem(16)} 0;
            ${siteWidthStyles()}
            flex-wrap: wrap;

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smaller};
            `}

            ${Slash} {
                margin: 0 ${pxToRem(5)};
            }

            a {
                ${linkStyles("inherit", "text.linkAltHover", false, true)}
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
            }

            [aria-current="page"] {
                font-weight: ${x => x.theme.design.typography.weight.bold}; /* Store Custom Code */
            }
        `,
    },
};

export default breadcrumbs;
